// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"RewardAlert_wrapper_bXEU3","reward":"RewardAlert_reward_2XTz0"};